// @flow
import styled from 'styled-components';
import { below } from '../../assets/css/media';

export const TeamName = styled.p`
	font-weight: bold;
	${below.desktop`
		width: 40%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		margin-right: 10px;
	`}
`;

export default TeamName;


// WEBPACK FOOTER //
// ./src/components/Team/TeamName.js